/* eslint import/prefer-default-export: 0 */

import fetchService from '@xanadu/ui-shared/utils/fetchService';

const OPTIONS = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Id-Type': 'String'
  }
};

export function sendNewTicketCreationRequest(payload) {
  const {
    formTitle,
    name,
    phone,
    mail,
    message,
    zendeskQueue
  } = payload;

  const body = {
    data: {
      'queue-id': zendeskQueue,
      requester: mail,
      subject: formTitle,
      body: `${name ? `From ${name} ` : ''}${phone ? `${phone} ` : ''}${name || phone ? ':\n' : ''}${message}`,
    }
  };

  const url = '/zendesk/api/v1/tickets';
  const options = {
    ...OPTIONS,
    method: 'POST',
    body: JSON.stringify(body)
  };

  return fetchService(url, options);
}
